import React from "react";

// Our catalog's action vocabulary (create/view/update/delete/write/manage/
// configure/use/...) is broader than the old stub's fixed 6 actions, so icons
// are keyed off a coarse bucket derived from the code suffix rather than an
// exact action match. Unknown suffixes fall back to "manage".
export type ActionBucket = "view" | "create" | "delete" | "manage";

export function actionBucket(code: string): ActionBucket {
  const action = code.split(".").slice(1).join(".");
  if (action.startsWith("view")) return "view";
  if (action === "create") return "create";
  if (action.startsWith("delete")) return "delete";
  return "manage";
}

export const TONE_TEXT: Record<ActionBucket, string> = {
  view:   "text-blue-600",
  create: "text-green-600",
  delete: "text-red-500",
  manage: "text-amber-500",
};

export const ACTION_ICON: Record<ActionBucket, React.ReactNode> = {
  view: (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
    </svg>
  ),
  create: (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
    </svg>
  ),
  delete: (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="3 6 5 6 21 6"/>
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
    </svg>
  ),
  manage: (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
    </svg>
  ),
};

// A code being deletion-shaped or a staff/role-management code gets a red
// confirm-before-check treatment - these are the highest-blast-radius grants.
export function isDangerous(code: string): boolean {
  return code.startsWith("records.delete") || code === "roles.manage" || code === "data.export";
}
